<!--意见反馈-->
<template>
  <div class="feedback-container">
    <div class="feedback-content">
      <p class="title SourceHanSansCN">意见反馈</p>
      <p class="smaller-title SourceHanSansCN">问题/意见描述</p>
      <el-input v-model="feedbackInfo.describe" type="textarea" placeholder="请输入10字以上的问题描述，以便我们更好的帮你解决问题"
                maxlength="300" minlength="10" show-word-limit :autosize="{ minRows: 5}" style="width: 60%"/>
      <p class="smaller-title SourceHanSansCN">上传问题截图，最多4张</p>
      <el-upload action="http://bqwapi.bangqichat.com/home/rest/uploadImgForWangsuyun/uploadImg" :limit="4" ref="upload"
                 list-type="picture-card" :file-list="fileList" :on-exceed="handleExceed" :multiple="true"
                 :on-success="successUpload" accept=".png,.gif,.jpeg,.jpg" :on-preview="handlePictureCardPreview"
                 :on-remove="handleRemove">
        <i class="el-icon-plus"></i>
      </el-upload>
      <p class="smaller-title SourceHanSansCN">联系方式（选填）</p>
      <el-input v-model="feedbackInfo.telephone" placeholder="请输入手机号码或邮箱，便于我们与你联系" style="width: 60%"/>
      <p>
        <el-button type="danger" @click="submitFeedback">提交</el-button>
      </p>
    </div>
    <el-dialog :visible.sync="dialogVisible" title="图片预览" width="550px">
      <el-image :src="dialogImageUrl" style="width: 500px;height: auto"/>
    </el-dialog>
  </div>
</template>

<script>
import {saveFeedBack} from '@/api/currencyApi'

export default {
  name: "feedback",
  data() {
    return {
      feedbackInfo: {
        describe: '',
        fileList: [],
        telephone: '',
      },
      fileList: [],
      dialogImageUrl: '',
      dialogVisible: false,
    }
  },
  methods: {
    handleRemove(file, fileList) {
      for (let i in this.feedbackInfo.fileList) {
        if (this.feedbackInfo.fileList[i] == file.response.imgPath) {
          this.feedbackInfo.fileList.splice(i, 1)
        }
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleExceed(files, fileList) {
      this.$message.error(`已超过上传上限！`);
    },
    successUpload(response, file, fileList) {
      this.feedbackInfo.fileList.push(response.imgPath);
    },
    submitFeedback() {
      if (this.feedbackInfo.describe == '') {
        this.$message.error('问题描述不能为空。')
        return
      }
      if (this.feedbackInfo.describe.length < 10) {
        this.$message.error('问题描述不能少于10个字。')
        return
      }
      let cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
      saveFeedBack({
        cid:cid!=0 && cid!=undefined ? cid : 0,
        uid:cid!=0 && cid!=undefined ? cid : 0,
        contact_way:this.feedbackInfo.telephone,
        content:this.feedbackInfo.describe,
        img:this.feedbackInfo.fileList.join(',')
      }).then(res=>{
        if (res.code==200){
          this.$message.success('您的意见已提交。')
          this.feedbackInfo= {describe: '', fileList: [], telephone: ''}
          this.fileList=[];
        }else {
          this.$message.error('操作失败。')
        }
      })
    }
  }
}
</script>
<style scoped>
.feedback-container >>> .feedback-content .el-button--danger {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
}

.feedback-container >>> .feedback-content .el-button--danger:hover {
  color: #f56c6c;
  background: #fef0f0;
  border-color: #fbc4c4;
}

.feedback-container >>> .feedback-content input::-webkit-input-placeholder {
  color: #999999;
}

.feedback-container >>> .feedback-content .el-textarea textarea ::-webkit-input-placeholder {
  color: #999999;
}
</style>
<style scoped lang="scss">
.feedback-container {
  background: #ffffff;

  .feedback-content {
    padding: 20px;

    .title {
      margin-block-start: 0px;
      margin-block-end: 0px;
      font-size: 16px;
      color: #333333;
    }

    .smaller-title {
      font-size: 14px;
      color: #333333;
    }
  }
}
</style>